import type {JSONValue} from 'types';
import {CollectionSubTypes} from 'types';
import {normalizeQuery} from 'api/functions';
import {mapToCollectionTypeDto} from 'services/series';
import type {SearchProps, SeriesCountSearchProps} from '../types';
import seriesQuery from '../data/seriesQuery.json';

const SERIES_INDEX = 'ebs-series-alias';

export const mapSeriesCountSearchPropsToSearchProps = ({
  query,
  abortSignal,
}: SeriesCountSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);

  const elasticBody: JSONValue[] = CollectionSubTypes.map(subType => {
    const {query: subQuery} = JSON.parse(
      JSON.stringify(seriesQuery)
        .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
        .replaceAll(
          '${SERIES_TYPE_PLACEHOLDER}',
          mapToCollectionTypeDto(subType),
        ),
    );
    return {size: 0, query: subQuery};
  });

  return {
    target: '_msearch',
    index: SERIES_INDEX,
    elasticBody,
    abortSignal,
  };
};
